import { FormCheckbox, GovFormWeb } from '@gov-design-system-ce/react-form';
import {
	DataBoxConnectDialogVariant,
	useDataBoxConnectDialogForm,
	useDataBoxMatomo,
} from '@gov-nx/module/data-box';
import {
	Button,
	Dialog,
	FormSideOffsetLayout,
	LayoutGap,
} from '@gov-nx/ui/web';
import { MarkdownRender } from '../../Markdown/MarkdownRender';
import { ContinueButton } from './ContinueButton';
import { useConfiguration } from '@gov-nx/core/service';

interface DataBoxConnectDialogFormProps {
	isOpen: boolean;
	mainKey: string;
	modalVariant: DataBoxConnectDialogVariant;
	closeModal: () => void;
	ts: (key: string) => string;
}

export const DataBoxConnectDialogForm = (
	props: DataBoxConnectDialogFormProps
) => {
	const { isOpen, mainKey, closeModal, modalVariant, ts } = props;
	const { form, formId, isConsentVisible, strings } =
		useDataBoxConnectDialogForm(modalVariant);
	const {
		zalozeniDatoveSchrankyUrl: creationUrl,
		pripojeniDatoveSchrankyUrl: connectionUrl,
	} = useConfiguration();
	const { trackEvent } = useDataBoxMatomo();

	const onSubmit = form.formMethods.handleSubmit(() => {
		if (modalVariant === DataBoxConnectDialogVariant.Create) {
			trackEvent({ action: 'create_redirect' });
			window.location.href = creationUrl;
		} else {
			trackEvent({ action: 'connect_redirect' });
			window.location.href = connectionUrl;
		}
	});

	return (
		<Dialog
			isOpen={isOpen}
			onClose={closeModal}
			title={<h3>{ts('datova-schranka.modal.' + mainKey + '.nadpis')}</h3>}
			footer={
				<>
					<Button
						color="primary"
						aria-label={ts('datova-schranka.modal.' + mainKey + '.wcag.zrusit')}
						type="outlined"
						isExpandedMobile
						size="m"
						onClick={closeModal}>
						{ts('datova-schranka.modal.' + mainKey + '.zrusit')}
					</Button>
					{modalVariant === DataBoxConnectDialogVariant.Connect && (
						<ContinueButton
							mainKey="pripojeni"
							formId={formId}
							ts={ts}
						/>
					)}
					{modalVariant === DataBoxConnectDialogVariant.Create && (
						<ContinueButton
							mainKey="zalozeni"
							formId={formId}
							ts={ts}
						/>
					)}
				</>
			}>
			<GovFormWeb
				id={formId}
				onSubmit={onSubmit}
				formDefinition={form}>
				<LayoutGap gap="m">
					<MarkdownRender>
						{ts('datova-schranka.modal.' + mainKey + '.popis')}
					</MarkdownRender>
					{isConsentVisible && (
						<LayoutGap gap="none">
							<FormCheckbox {...form.fields.souhlas} />
							<FormSideOffsetLayout>
								<MarkdownRender
									applyClasses={{
										paragraph: 'text-body-s! text-(--text-secondary)',
									}}>
									{strings.explanation}
								</MarkdownRender>
							</FormSideOffsetLayout>
						</LayoutGap>
					)}
				</LayoutGap>
			</GovFormWeb>
		</Dialog>
	);
};
